export const COLOR_PALLETES = [
    //https://learnui.design/tools/data-color-picker.html#divergent
    //https://color.adobe.com/explore
    [
        "#4b5359",
        "#545f6e",
        "#656883",
        "#7e7093",
        "#9d769d",
        "#be7b9f",
        "#dd8299",
        "#f58c8d",
    ],
    [
        "#0788d9",
        "#009ee2",
        "#00b0d8",
        "#00bfbd",
        "#00cb98",
        "#5cd46e",
        "#acd749",
        "#f2d338",
    ],
    [
        "#ec2125",
        "#f15105",
        "#f07400",
        "#eb9400",
        "#e1b100",
        "#d4cc00",
        "#c2e61f",
        "#aaff53",
    ],
    [
        "#8c116b",
        "#8258a8",
        "#6f8ad1",
        "#73b5e5",
        "#9cdcf0",
        "#d7ffff",
        "#befdfd",
        "#a4fafa",
        "#85f8f8",
        "#5ef5f5",
        "#05f2f2",
    ],
    [
        "#009418",
        "#00ab51",
        "#00c180",
        "#00d6ad",
        "#00ebd8",
        "#40ffff",
        "#0ccadc",
        "#0097b2",
        "#036784",
        "#083c54",
        "#011526",
    ],
    // [
    //     "#d9303e",
    //     "#e26743",
    //     "#e99256",
    //     "#eeb876",
    //     "#f4db9f",
    //     "#fffbcf",
    //     "#ecf2ad",
    //     "#d3ea8e",
    //     "#b4e371",
    //     "#8ddc58",
    //     "#58d543",
    // ],
    [
        "#020540",
        "#3b2a62",
        "#6b5187",
        "#9c7cad",
        "#cdaad5",
        "#ffdbff",
        "#ffb7e8",
        "#ff90c3",
        "#ff6591",
        "#ff3855",
        "#f20505",
    ],
    [
        "#0ed2e9",
        "#26dbdb",
        "#50e2c8",
        "#77e8b4",
        "#9eeba0",
        "#c4ed8f",
        "#cbce60",
        "#d2ae37",
        "#d8891a",
        "#db6016",
        "#d92525",
    ],
    [
        "#b246f2",
        "#6789ff",
        "#0cb4ff",
        "#50d3ff",
        "#a1ecff",
        "#ecffff",
        "#bcfef6",
        "#8dfbe1",
        "#66f6c1",
        "#4eef97",
        "#4ee662",
    ],
    [
        "#52188c",
        "#902888",
        "#bb4986",
        "#d9708a",
        "#ef9997",
        "#ffc2b0",
        "#ffbb93",
        "#f5b875",
        "#e2b957",
        "#c6bb3b",
        "#9ebf26",
    ],
    [
        "#d92525",
        "#ef4e62",
        "#fa7798",
        "#fd9fc5",
        "#fcc6e8",
        "#ffeaff",
        "#ece1fc",
        "#d6d9f8",
        "#bdd1f1",
        "#a4cae7",
        "#8bc3d9",
    ],
]
export const PIE_CHART_CHUNK_MOBILE = 1;
export const PIE_CHART_CHUNK_DESKTOP = 2;
export const PIE_CHART_CHUNK_LARGER_DESKTOP = 3;
export const LINE_CHART_CHUNK = 1;